'use strict';

import React, { Component } from 'react';
import Table from './Table.jsx';
import { LogHelper } from 'com-gyf-webcore-loghelper';

/**
 * Clase que representa la distribucion de limites - tarjetas
 */
class DistribucionLimitesCards extends Component {
    constructor(props) {
        super(props)
        this.state = {
            empresas: props.data.empresas,
            cuentas: props.data.cuentas,
            tarjetas: props.data.tarjetas,
            novedadesEmpresas: props.data.novedadesEmpresas,
            novedadesCuentas: props.data.novedadesCuentas,
            novedadesTarjetas: props.data.novedadesTarjetas,
            functions: props.data.functions,
            administradoraSeleccionadaId: props.data.administradoraSeleccionadaId,
            seEstaEditando: props.data.seEstaEditando,
            limiteCliente: props.data.limiteCliente,
            estadoMostrarMensajeLimitesIguales: props.data.estadoMostrarMensajeLimitesIguales,
            empresaId: undefined,
            cuentaTarjetaId: undefined
        };
    }

    /**
     * Muestra mensaje cuando el limite es igual al que existia
     * @param {any} estado Parametro booleano
     */
    mostrarMensajeLimitesIguales(estado) {
        this.setState({ estadoMostrarMensajeLimitesIguales: estado });
    }
    /**
     * Cambia el estado de la fila indicando si es edición o no
     * @param {any} valor Parametro booleano
     */
    cambiarModoEdicion(valor) {
        this.setState({ seEstaEditando: valor, estadoMostrarMensajeLimitesIguales: false }, this.actualizarEstadoPadre(valor));
    }
    /**
     * Maneja el cambio de estado de la empresa
     * @param {any} event
     */
    cambiarEmpresa(event) {
        this.setState({ empresaId: event.target.value });
    }

    /**
     * Maneja el cambio de estado al cambiar la cuenta
     * @param {any} event
     */
    cambiarCuenta(event) {
        this.setState({ cuentaTarjetaId: event.target.value });
    }

    /**
     * Actualiza los limites de las tarjetas o novedades segun corresponda
     * @param {any} tarjetaId Parametro entero, representa el id de la tarjeta
     * @param {any} limite Parametro entero, reprenseta el limite de la tarjeta 1 - 99 en %
     * @param {any} seleccionarTodasAsig Parametro booleano, determina si se tienen que aplicar a todas las tarjetas o no
     */
    cambiarLimite(tarjetaId, limite, seleccionarTodasAsig, cuentaId) {
        let tarjetas = this.state.tarjetas;
        let novedades = this.state.novedadesTarjetas;
        let cuenta = this.props.data.cuentas.find((cuenta) => cuenta.Id == cuentaId);

        //Recorro todas las tarjetas
        tarjetas.filter((tar1) => (tar1.CuentaId || tar1.CuentaTarjetaId) == cuenta.Id).forEach((tar2) => {
            //Busco las novedades para la tarjeta
            let novedad = undefined;

            //Si hay que asignar el valor a todas las tarjetas
            if (seleccionarTodasAsig == true) {
                tar2.Editado = true;
                novedad = novedades.find((n) => { return n.TarjetaCreditoId == tar2.Id });
                //Si la novedad existe
                if (novedad) {
                    //Guardo el valor
                    novedad.ValorNovedad = limite;
                } else {
                    //Seteo el nuevo limite
                    tar2.Limite = limite;
                }
                //Busca la tarjeta por Id
            } else {
                //Busco la tarjeta que se modifico, es decir la que llega por parametro
                if (tar2.Id == tarjetaId) {
                    tar2.Editado = true;
                    novedad = novedades.find((n) => { return n.TarjetaCreditoId == tarjetaId });
                    //Si la novedad existe
                    if (novedad) {
                        //Guardo el valor
                        novedad.ValorNovedad = limite;
                    } else {
                        //Seteo el nuevo limite
                        tar2.Limite = limite;
                    }
                }
            }

            //Si el limite no cambio lo dejo como estaba para el resto de las tarjetas
            tar2.PorcentajeLimiteCompra = (tar2.Limite || tar2.PorcentajeLimiteCompra);
            tar2.Valor = (cuenta.Valor * tar2.PorcentajeLimiteCompra) / 100;
        });

        //Cambio el estado y actualizo al componente padre
        this.setState({
            tarjetas: tarjetas,
            novedadesTarjetas: novedades,
            seEstaEditando: false
        }, this.actualizarEstadoPadre(false));
    }

    /**
     * Actualiza los datos del estado del componente padre.
     * @param {any} seEstaEditando Parametro booleano que determina si se esta editando o no
     */
    actualizarEstadoPadre(seEstaEditando) {
        let estado = {
            tarjetas: this.state.tarjetas,
            novedadesTarjetas: this.state.novedadesTarjetas,
            seEstaEditando
        }
        this.props.cambiarEstadoEdicion(estado);
    }

    render() {
        //Seteo el estado global...
        let data = this.state;

        if (data != undefined) {
            return (<div className="container-fluid bottom-separator-xxs">
                <Table
                    limitesCliente={this.props.limitesCliente}
                    data={data}
                    nuevaData={this.props.data}
                    cambiarEmpresa={this.cambiarEmpresa.bind(this)}
                    cambiarCuenta={this.cambiarCuenta.bind(this)}
                    cambiarLimite={(id, limite, seleccionarTodasAsig, cuentaId) => { this.cambiarLimite(id, limite, seleccionarTodasAsig, cuentaId) }}
                    cambiarModoEdicion={(valor) => { this.cambiarModoEdicion(valor) }}
                    mostrarMensajeLimitesIguales={(estado) => { this.mostrarMensajeLimitesIguales(estado) }}
                    novedadesTarjetas={this.state.novedadesTarjetas}
                    functions={this.props.functions} />
            </div>);
        }
        else {
            return null;
        }
    }
}

export default DistribucionLimitesCards;
